const API_ENDPOINT = "https://ra.dga.jp/cgi-bin/ra/KAN041-JSONP";
const PROD_ORIGIN = "https://www.daily.co.jp";
const APPEND_CALLBACK_PARAM = false;

// ====== 内部：JSONP 取得（結果はモジュール内でキャッシュ） ======
let _fetchPromise = null;
function fetchRelationsOnce({ timeout = 1000, link = location.href } = {}) {
  if (_fetchPromise) return _fetchPromise;
  _fetchPromise = new Promise((resolve, reject) => {
    const prev = window.relation;
    let settled = false;

    const timer = setTimeout(() => {
      if (!settled) { settled = true; cleanup(); reject(new Error("JSONP timeout")); }
    }, timeout);

    window.relation = (data) => {
      if (settled) return;
      settled = true; clearTimeout(timer); cleanup(); resolve(Array.isArray(data) ? data : []);
    };

    let lUrl = link;
    const u = new URL(link);
    const p = new URL(PROD_ORIGIN);
    p.pathname = u.pathname;
    lUrl = p.toString();
    const qs = new URLSearchParams({ cs: "utf8", l: lUrl });
    if (APPEND_CALLBACK_PARAM) qs.set("callback", "relation");
    const s = document.createElement("script");
    s.src = `${API_ENDPOINT}?${qs.toString()}`;
    s.async = true;
    s.onerror = () => {
      if (!settled) { settled = true; clearTimeout(timer); cleanup(); reject(new Error("JSONP load error")); }
    };
    document.head.appendChild(s);

    function cleanup() {
      if (s.parentNode) s.parentNode.removeChild(s);
      if (typeof prev === "function") window.relation = prev;
      else { try { delete window.relation; } catch (e) { window.relation = undefined; } }
    }
  });
  return _fetchPromise;
}

// ====== 公開：事前ロード ======
async function preloadRelations(opts) {
  try { await fetchRelationsOnce(opts); } catch (e) {}
}

// ====== 公開：取得結果を使って描画 ======
/**
 *
 * @param {HTMLElement|string} target - 追加先の要素 or セレクタ
 * @param {{
 *   isMobile: boolean,      // モバイルかどうか
 *   articleGnere: string,   // 記事ジャンル
 * }} opts
 * @returns
 */
async function renderRelationsAuto(
  target,
  {
    isMobile,
    articleGenre = "", // tigers, gossip, umaya, ...
  } = {}
) {

  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (!el) return;

  let data = [];
  try { data = await fetchRelationsOnce(); } catch (e) {}
  if (!Array.isArray(data) || data.length === 0) {
    el.remove(); // “データが取れたときだけ描画”
    return;
  }

  // 描画分岐
  el.textContent = "";

  if (isMobile) { // Mobile
    if (articleGenre === 'umaya') {
      el.appendChild( renderMobile_uma(data, { adSlotId: "dssp-relation" }) );
    } else {
      el.appendChild( renderMobile(data, { adSlotId: "dssp-relation", articleGenre: articleGenre }) );
    }

  } else { // Desktop
    if (articleGenre === 'gossip') {
      el.appendChild( renderDesktop_Text(data, {adSlotId: "dspc-relation"}) );
      // safeRefreshGpt("dspc-relation", "/21662775423/dspc/text/relation", ["fluid", [1,1]]);
    } else if (articleGenre === 'umaya') {
      el.appendChild( renderDesktop_uma(data, {adSlotId: "dspc-relation"}) );
      // safeRefreshGpt("dspc-relation-umaya", "/21662775423/dspc/special/relation_umaya", ["fluid", [163, 162]]);
    } else {
      el.appendChild( renderDesktop(data, { adSlotId: 'dspc-relation', adInsertAfter: 2 } ) );
      // safeRefreshGpt("dspc-relation_img", "/21662775423/dspc/relation_img", ["fluid", [1,1]]);
    }
  }
}


/* ----------------- 以下、描画実装 ----------------- */

// Mobile
function renderMobile(arr, { adSlotId, articleGenre }) {
  const ul = el("ul", { id: "relationNews", class: "ul_link inner" });
  for (let i = 0; i < arr.length; i++) {
    const it = arr[i] || {};
    if (articleGenre === 'tigers') {
      ul.appendChild(
        el("li", { class: "icondot relation-item" },
          linkArticle(it, { withImg: true, imgClass: "relation-img", titleClass: "relation-ttl" })
        )
      );
    } else {
      ul.appendChild(
        el("li", { class: "icondot" },
          el("a", { href: it.url || "#" }, text(it.title || it.url || ""))
        )
      );
    }
  }
  ul.appendChild( el("li", { class: "icondot" }, el("div", { id: adSlotId})) );
  return el("div", {},
    el("h2", {class: "ttlBasicSubhead"}, text("関連ニュース")),
    ul);
}
// Mobile umaya
function renderMobile_uma(arr, { adSlotId }) {
  const ol = el("ol", { id: "relationNews", class: "card-small" });
  const n = Math.min(arr.length, 5);
  for (let i = 0; i < n; i++) {
    const it = arr[i] || {};
    ol.appendChild(
      el("li", { class: "card-small-item" },
        el("a", { class: "card-small-anchor", href: it.url || "#" } ,
          it?.photo ?
            el("div", { class: "picture-fit-video" },
              el("img", { class: "picture-fit-body", src: it.photo, alt: it.title || "" })
            )
          : el("div", { class: "picture-fit-video no-image" }),
          el("p", {}, text(it.title || it.url || "")),
        )
      )
    );
  }
  ol.appendChild(
    el("li", { class: "card-small-item" },
      el("div", { id: adSlotId })
    )
  );
  return el("div", { class: "contents-basic" },
    el("h1", { class: "heading-article"}, text("関連ニュース")),
    ol);
}

// Desktop Text
function renderDesktop_Text(arr, { adSlotId }) {
  const ul = el("ul", { id: "relationNews", class: "linkLists txt-ellipsis" });
  for (const it of arr) {
    const h3 = el("h3", {}, text(it.title || it.url || ""));
    const article = el("article", {}, h3);
    const a = el("a", { href: it.url || "#" }, article);
    ul.appendChild(el("li", {}, a));
  }
  ul.appendChild(el("div", {id: adSlotId}, el("li", {})));
  return el("div", {},
    el("h2", { class: "ttl-section"}, text("関連ニュース")),
    ul
  );
}
// Desktop Photo
function renderDesktop(arr, { adSlotId , adInsertAfter }) {
  const div = el("div", {}, el("h2", { class: "ttl-section"}, text("関連ニュース")) );
  const ul = el("ul", { id: "relationNews", class: "relationNewsList blockLists" });
  let mainUsed = false, count = 0;
  for (const it of arr) {
    const firstWithPhoto = it?.photo && !mainUsed;
    const li = el("li", { class: it?.photo ? (firstWithPhoto ? "mainThumb" : "addThumb") : undefined },
      el("a", { href: it?.url || "#" },
        el("article", {},
          el("span", { class: "ttlWrapper" }, el("h3", { class: "ttl" }, text(it?.title || it?.url || ""))),
          it?.photo ?
            el("figure", { class: "thumb" },
              el("img", { src: it.photo || "https://i.daily.jp/Koukoku/Images/ds_noimage.jpg", alt: it.title || "photo" })
            )
          : null
        )
      )
    );

    if (firstWithPhoto) {
      ul.insertBefore(li, ul.firstChild);
      mainUsed = true;
    } else {
      ul.appendChild(li);
    }

    if (count === adInsertAfter) {
      ul.appendChild( el("div", { id: adSlotId , style: "min-height:80px;" }) );
    }
    count++;
  }
  div.appendChild(ul);
  return div;
}
// Desktop umaya
function renderDesktop_uma(arr, { adSlotId }) {
  const ol = el("ol", {id: "relationNews", class: "card-small"});
  for (const it of arr) {
    ol.appendChild(
      el("li", { class: "card-small-item" },
        el("a", { class: "card-small-anchor", href: it?.url || "#" },
          it?.photo ?
            el("div", {class: "card-small-picture"},
              el("img", { class: "card-small-image", src: it.photo, alt: it.title || "photo" }))
          : el("div", {class: "card-small-image no-image"}),
          el("p", {} , text(it.title || it.url || ""))
        )
      )
    );
  }
  ol.appendChild( el("span", {class: "card-small-item"}, el("div", {id: adSlotId})) );

  return el("div", {class: "contents-basic"},
    el("h1", {class: "heading-article"}, text("関連ニュース")),
    ol
  );
}


/* ----------------- ヘルパ ----------------- */

function linkArticle(it, { withImg, imgClass, titleClass, placeholder='https://i.daily.jp/Koukoku/Images/ds_noimage.jpg' }) {
  const a = el("a", { href: it.url || "#" });
  if (withImg) {
    a.appendChild(el("img", {
      class: imgClass,
      src: it.photo || placeholder,
      alt: "",
      loading: "lazy",
      referrerpolicy: "no-referrer",
    }));
  }
  a.appendChild(el("h3", { class: titleClass }, text(it.title || it.url || "")));
  return a;
}

function el(tag, attrs = {}, ...children) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs || {})) {
    if (v == null) continue;
    if (k === "class") node.className = v;
    else if (k === "style" && typeof v === "object") Object.assign(node.style, v);
    else node.setAttribute(k, String(v));
  }
  for (const c of children) {
    if (c == null) continue;
    if (typeof c === "string") node.appendChild(document.createTextNode(c));
    else node.appendChild(c);
  }
  return node;
}
const text = (s) => document.createTextNode(String(s ?? ""));

function safeRefreshGpt(slotId, adUnitPath, sizes) {
  window.googletag = window.googletag || { cmd: [] }; // googletagオブジェクトとcmd配列を安全に初期化・取得
  const g = window.googletag;
  g.cmd.push(function () {
    try {
      // 念のため、すでに同じIDでスロットが定義されていないかチェック
      const existingSlots = g.pubads().getSlots();
      const isAlreadyDefined = existingSlots.some(s => s.getSlotElementId() === slotId);

      if (!isAlreadyDefined) {
        const slot = g.defineSlot(adUnitPath, sizes, slotId).addService(g.pubads());
        g.display(slotId);
        g.pubads().refresh([slot]);
      } else {
        // すでに定義済みの場合は再描画のみ行うなどの処理（必要に応じて）
        g.pubads().refresh([existingSlots.find(s => s.getSlotElementId() === slotId)]);
      }
    } catch (e) {
      console.error("GPT render error:", e);
    }
  });
}

window.renderRelationsAuto = renderRelationsAuto;
window.preloadRelations = preloadRelations;
